var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/Auth/AuthConnect.ts";
import { Auth } from './Auth';
export function authConnect(fetchService) {
  Auth.User.fetchList.use(function (params) {
    return fetchService.post("/auth/users", {
      ids: params.ids ? params.ids : [],
      projectUrn: params.projectUrn
    }).then(Auth.User.fetchList.toPromise);
  });
  Auth.User.fetch.use(function () {
    return fetchService.get("/auth/current-user").then(Auth.User.fetch.toPromise);
  });
  Auth.Role.fetchList.use(function (params) {
    return fetchService.get("/auth/roles", params).then(Auth.Role.fetchList.toPromise);
  });
}